import Index from '@/components/home';

export default function Page() {
  return <Index />;
}

// Page.getLayout = getTabNavigatorLayout;
